"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _stores = require("@seedlang/stores");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _utils = require("@seedlang/utils");
var _root_state = _interopRequireDefault(require("./root_state"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ForumUI = (_class = /*#__PURE__*/function (_RootState) {
  function ForumUI() {
    var _this;
    _classCallCheck(this, ForumUI);
    _this = _callSuper(this, ForumUI);
    _initializerDefineProperty(_this, "editComment", _descriptor, _this);
    _initializerDefineProperty(_this, "editForumThread", _descriptor2, _this);
    _initializerDefineProperty(_this, "title", _descriptor3, _this);
    _initializerDefineProperty(_this, "body", _descriptor4, _this);
    _initializerDefineProperty(_this, "caretPositionBody", _descriptor5, _this);
    _initializerDefineProperty(_this, "caretPositionTitle", _descriptor6, _this);
    _initializerDefineProperty(_this, "forumThreadId", _descriptor7, _this);
    _initializerDefineProperty(_this, "forumId", _descriptor8, _this);
    _initializerDefineProperty(_this, "submitting", _descriptor9, _this);
    _initializerDefineProperty(_this, "postAsUser", _descriptor10, _this);
    _initializerDefineProperty(_this, "postAsSeedlang", _descriptor11, _this);
    _initializerDefineProperty(_this, "word", _descriptor12, _this);
    _initializerDefineProperty(_this, "sentenceId", _descriptor13, _this);
    _initializerDefineProperty(_this, "sentenceTargetText", _descriptor14, _this);
    _this.authUserStore = _stores.AuthUserStore;
    _this.forumStore = _stores.ForumStore;
    _this.forumThreadStore = _stores.ForumThreadStore;
    _this.routeStore = _stores.RouteStore;
    _this.commentStore = _stores.CommentStore;
    _this.feedbackStore = _stores.FeedbackStore;
    _this.userStore = _stores.UserStore;
    return _this;
  }
  _inherits(ForumUI, _RootState);
  return _createClass(ForumUI, [{
    key: "user",
    get: function get() {
      return this.authUserStore.showData;
    }
  }, {
    key: "userIsLoaded",
    get: function get() {
      return (0, _utils.isPresent)(this.user.id);
    }
  }, {
    key: "loadForum",
    value: function loadForum(forumId, forceLoad) {
      if (forumId) {
        this.forumId = forumId;
      }
      if (forceLoad || !this.forumStore.hasShowData || this.forumStore.showData.id !== this.forumId) {
        this.forumStore.getShow({
          queryStrings: {
            without_comments: true
          },
          ids: {
            forumId: this.forumId
          }
        });
      }
    }
  }, {
    key: "loadForumThread",
    value: function loadForumThread(forumThreadId) {
      if (forumThreadId) {
        this.forumThreadId = forumThreadId;
      }
      if (this.forumThreadId) {
        this.forumThreadStore.getShow({
          queryStrings: {
            without_comments: true
          },
          ids: {
            forumThreadId: this.forumThreadId
          }
        });
      }
    }
  }, {
    key: "hasForumThread",
    get: function get() {
      return this.forumThreadStore.hasShowData;
    }
  }, {
    key: "dropInForumThread",
    get: function get() {
      return (0, _utils.isPresent)(this.forumThread.referralRoute);
    }
  }, {
    key: "hasForum",
    get: function get() {
      return this.forumStore.hasShowData;
    }
  }, {
    key: "forum",
    get: function get() {
      return this.forumStore.showData;
    }
  }, {
    key: "forumThread",
    get: function get() {
      return this.forumThreadStore.showData;
    }
  }, {
    key: "disabledForumThread",
    get: function get() {
      return this.submitting || ((0, _utils.isBlank)(this.body) || (0, _utils.isBlank)(this.title)) && (0, _utils.isBlank)(this.sentenceId) && (0, _utils.isBlank)(this.word);
    }
  }, {
    key: "toggleEditForumThread",
    value: function toggleEditForumThread() {
      if (this.editForumThread) {
        this.body = null;
        this.title = null;
      } else {
        this.body = this.forumThread.body;
        this.title = this.forumThread.title;
      }
      this.editForumThread = !this.editForumThread;
    }
  }, {
    key: "onSetWord",
    value: function onSetWord(word) {
      this.word = word;
    }
  }, {
    key: "onDestroyThread",
    value: function onDestroyThread() {
      this.forumThreadStore.destroy({
        ids: {
          forumThreadId: this.forumThread.id
        }
      }, this.afterDestroyForumThread);
    }
  }, {
    key: "afterDestroyForumThread",
    value: function afterDestroyForumThread() {
      this.routeStore.routeToNamed('forums.show', {
        page: 1,
        forumId: this.forumId
      });
    }
  }, {
    key: "onTogglePinned",
    value: function onTogglePinned() {
      var _this2 = this;
      this.forumThreadStore.update({
        ids: {
          forumThreadId: this.forumThread.id
        },
        data: {
          pinned: !this.forumThread.pinned
        }
      }, function () {
        return _this2.loadForumThread();
      });
    }
  }, {
    key: "onToggleSeenByAdmin",
    value: function onToggleSeenByAdmin() {
      var _this3 = this;
      var newValue = !this.forumThread.seenByAdmin;
      this.forumThread.set('seenByAdmin', newValue);
      this.forumThreadStore.update({
        ids: {
          forumThreadId: this.forumThread.id
        },
        data: {
          seen_by_admin: newValue
        }
      }, function () {
        _this3.loadForumThread();
        _this3.loadForum(_this3.forumId, true);
      });
    }
  }, {
    key: "onSetTag",
    value: function onSetTag(tag) {
      var _this4 = this;
      var ary = this.forumThreadStore.showData.tag ? this.forumThreadStore.showData.tag.split(',') : [];
      if (ary.includes(tag)) {
        ary = ary.filter(function (item) {
          return item !== tag;
        });
      } else {
        ary.push(tag);
      }
      this.forumThread.set('tag', ary.join(','));
      this.forumThreadStore.update({
        ids: {
          forumThreadId: this.forumThread.id
        },
        data: {
          tag: ary.join(',')
        }
      }, function () {
        return _this4.loadForumThread();
      });
    }
  }, {
    key: "onCreateForumThread",
    value: function onCreateForumThread(forumId, groupId, languageId) {
      this.groupId = groupId;
      this.languageId = languageId;
      var callback;
      if (groupId) {
        callback = this.onAfterCreateForumThreadRedirectClassroom;
      } else if (languageId) {
        callback = this.onAfterCreateForumThreadRedirectTranslator;
      } else {
        callback = this.onAfterCreateForumThreadRedirectForum;
      }
      if (forumId) {
        this.forumId = forumId;
      }
      var userId;
      if (!this.postAsSeedlang) {
        userId = this.postAsUser && this.postAsUser.id ? this.postAsUser.id : this.user.id;
      }
      if (this.editForumThread) {
        this.forumThreadStore.update({
          ids: {
            forumThreadId: this.forumThread.id
          },
          data: {
            body: this.body,
            title: this.title
          }
        }, this.onAfterUpdateForumThread.bind(this));
      } else if (!this.disabled) {
        this.forumThreadStore.create({
          data: {
            user_id: userId,
            word_id: this.word && this.word.id,
            sentence_id: this.sentenceId,
            body: this.body,
            title: this.word || this.sentenceId ? null : this.title,
            forumId: forumId
          }
        }, callback);
      }
    }
  }, {
    key: "onCreateComment",
    value: function onCreateComment(params, callback) {
      if (!this.submitting) {
        this.submitting = true;
        if (this.editComment) {
          this.commentStore.update({
            ids: {
              commentId: this.editComment.id
            },
            data: {
              text: params.text,
              updated: true
            }
          }, callback || this.onAfterCreateComment.bind(this));
        } else {
          this.commentStore.create({
            data: {
              text: params.text,
              user_id: this.user.id,
              commentable_id: params.commentableId,
              parent_id: params.parentId,
              word_id: params.wordId,
              sentence_id: params.sentenceId,
              concept_id: params.conceptId,
              faq_item_id: params.faqItemId,
              commentable_type: params.commentableType,
              debug_info: params.debugInfo,
              comment_type: 'response',
              xp: 2,
              xp_slug: 'comment'
            }
          }, callback || this.onAfterCreateComment.bind(this));
        }
      }
    }
  }, {
    key: "onAfterCreateComment",
    value: function onAfterCreateComment(resp) {
      this.submitting = false;
      this.editComment = null;
      this.loadForumThread(resp.commentableId);
      this.onResetPost();
    }
  }, {
    key: "onAfterCreateForumThreadRedirectForum",
    value: function onAfterCreateForumThreadRedirectForum(resp) {
      this.routeStore.routeToNamed('forums.forum_threads.show', {
        forumId: this.forumId,
        forumThreadId: resp.id
      });
      this.onReset();
    }
  }, {
    key: "onAfterCreateForumThreadRedirectTranslator",
    value: function onAfterCreateForumThreadRedirectTranslator(resp) {
      this.routeStore.routeToNamed('translator.home', {
        languageId: this.languageId,
        forumThreadId: resp.id
      });
      this.onReset();
    }
  }, {
    key: "onAfterCreateForumThreadRedirectClassroom",
    value: function onAfterCreateForumThreadRedirectClassroom(resp) {
      this.routeStore.routeToNamed('classroom.forum_threads.show', {
        groupId: this.groupId,
        forumThreadId: resp.id
      });
      this.onReset();
    }
  }, {
    key: "onAfterUpdateForumThread",
    value: function onAfterUpdateForumThread() {
      this.submitting = false;
      this.loadForumThread(this.forumThread.id);
      this.onReset();
    }
  }, {
    key: "onReset",
    value: function onReset() {
      this.word = null;
      this.sentenceId = null;
      this.sentenceTargetText = null;
      this.editForumThread = false;
      this.postAsUser = null;
      this.editComment = null;
      this.submitting = false;
      this.body = '';
      this.title = '';
      this.caretPositionBody = null;
      this.caretPositionTitle = null;
      this.forumThreadId = null;
    }
  }, {
    key: "onResetPost",
    value: function onResetPost() {
      this.body = '';
    }
  }, {
    key: "cancelEditComment",
    value: function cancelEditComment() {
      this.editComment = null;
      this.body = null;
    }
  }, {
    key: "onChangeBody",
    value: function onChangeBody(value) {
      var el = document.getElementById('forum-body');
      this.body = value;
      if (el) {
        this.caretPositionBody = el.selectionStart;
      }
    }
  }, {
    key: "onChangeTitle",
    value: function onChangeTitle(value) {
      var el = document.getElementById('forum-title');
      this.title = value;
      if (el) {
        this.caretPositionTitle = el.selectionStart;
      }
    }
  }, {
    key: "insertBodyText",
    value: function insertBodyText(text) {
      var el = document.getElementById('forum-body');
      if (el) {
        var caretPositionBody = el.selectionStart;
        var newValue = [this.body.slice(0, caretPositionBody), text, this.body.slice(caretPositionBody)].join('');
        this.caretPositionBody = caretPositionBody + 1;
        this.body = newValue;
      }
    }
  }, {
    key: "insertTitleText",
    value: function insertTitleText(text) {
      var el = document.getElementById('forum-title');
      var caretPositionTitle = el.selectionStart;
      var newValue = [this.title.slice(0, caretPositionTitle), text, this.title.slice(caretPositionTitle)].join('');
      this.caretPositionTitle = caretPositionTitle + 1;
      this.title = newValue;
    }
  }, {
    key: "setEditComment",
    value: function setEditComment(comment) {
      this.editComment = comment;
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "editComment", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "editForumThread", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "title", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "body", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "caretPositionBody", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "caretPositionTitle", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "forumThreadId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "forumId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "submitting", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "postAsUser", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "postAsSeedlang", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "word", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "sentenceId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "sentenceTargetText", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsLoaded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadForum", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "loadForum"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadForumThread", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "loadForumThread"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasForumThread", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasForumThread"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dropInForumThread", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "dropInForumThread"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasForum", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasForum"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "forum", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "forum"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "forumThread", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "forumThread"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disabledForumThread", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "disabledForumThread"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleEditForumThread", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "toggleEditForumThread"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSetWord", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onSetWord"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDestroyThread", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onDestroyThread"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterDestroyForumThread", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterDestroyForumThread"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTogglePinned", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onTogglePinned"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onToggleSeenByAdmin", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onToggleSeenByAdmin"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSetTag", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onSetTag"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCreateForumThread", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onCreateForumThread"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCreateComment", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onCreateComment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onAfterCreateComment", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onAfterCreateComment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onAfterCreateForumThreadRedirectForum", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onAfterCreateForumThreadRedirectForum"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onAfterCreateForumThreadRedirectTranslator", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onAfterCreateForumThreadRedirectTranslator"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onAfterCreateForumThreadRedirectClassroom", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onAfterCreateForumThreadRedirectClassroom"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onAfterUpdateForumThread", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onAfterUpdateForumThread"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onReset", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onReset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onResetPost", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onResetPost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelEditComment", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "cancelEditComment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChangeBody", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onChangeBody"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChangeTitle", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onChangeTitle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertBodyText", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "insertBodyText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertTitleText", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "insertTitleText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setEditComment", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setEditComment"), _class.prototype), _class);
var _default = exports["default"] = new ForumUI();